/**
 * System prompts API endpoints — T20.
 * Maps PRD §9.5 to typed fetch calls via apiClient.
 */
import {
  ListSystemPromptsResponseSchema,
  SystemPromptResponseSchema,
  type UpdateSystemPromptRequest,
} from '@malaberg/shared';
import { apiClient } from '../client';

export type SystemPromptName = 'main' | 'extra';

export const systemPromptsApi = {
  list() {
    return apiClient.request('GET', '/api/system-prompts', {
      schema: ListSystemPromptsResponseSchema,
    });
  },

  getVersions(name: SystemPromptName) {
    return apiClient.request('GET', `/api/system-prompts/${name}/versions`);
  },

  getVersion(name: SystemPromptName, version: number) {
    return apiClient.request('GET', `/api/system-prompts/${name}/versions/${version}`, {
      schema: SystemPromptResponseSchema,
    });
  },

  update(name: SystemPromptName, body: UpdateSystemPromptRequest) {
    return apiClient.request('PUT', `/api/system-prompts/${name}`, {
      body: JSON.stringify(body),
    });
  },

  revert(name: SystemPromptName, version: number) {
    return apiClient.request('POST', `/api/system-prompts/${name}/revert/${version}`, {
      body: JSON.stringify({}),
    });
  },
};
